import React, {DetailedHTMLProps, DOMAttributes, HTMLAttributes} from "react";
import {IFormElement} from "../model/FormModel";
import AppButton from "../../../element/button/AppButton";

interface IProps extends IFormElement
{
    message?: string | string[] | null;
    elementProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
    onCloseCallback?: () => void;
}

const AlertFE = (props: IProps) =>
{
    const {
        message,
        children,
        elementProps
    } = props;

    const messages: string[] = message ? (Array.isArray(message) ? message : [message]) : [];
    const className: string = elementProps?.className ? elementProps.className : "alert-danger"
    if (!messages.length && !children)
    {
        return <></>
    }
    return <div
        {...elementProps}
        className={"form-group mt-4 alert " + className}
        role="alert"
    >
        <div className="row">


            <div className={props.onCloseCallback ? "col-11" : "col-12"}>
                {messages.map((message, index) =>
                {
                    return <div key={index} dangerouslySetInnerHTML={{__html: message}}/>
                })}
                {children}
            </div>
            {props.onCloseCallback && <div className="col-1 text-end">

                <AppButton
                    nonButton={true}
                    onClick={props.onCloseCallback}
                >
                    <i
                        className="fa fa-solid fa-times"
                        aria-hidden="true"
                    ></i>
                </AppButton>
            </div>}
        </div>
    </div>;
}

export default AlertFE;